import { render, staticRenderFns } from "./Fab.vue?vue&type=template&id=1bf3a1be&"
import script from "./Fab.vue?vue&type=script&lang=js&"
export * from "./Fab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Fab.vue"
export default component.exports